<h1 mat-dialog-title>Prescripción</h1>

<div mat-dialog-content>
    <table class="table-prescription">
        <tr>
            <td class="action">

                <div [style.backgroundColor]="!prescriptionId? 'grey' : ''">
                    <button (click)="add()" mat-icon-button>
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
                <div [style.backgroundColor]="prescriptionId === id? 'grey' : ''" *ngFor="let id of data.prescriptionIds">
                    <img (click)="view(id)" class="download-prescription" src="../../../../Content/Images/article-24px.svg">
                </div>

                <mat-spinner *ngIf="isDownloadAll" [diameter]="30">
                </mat-spinner>
                <button *ngIf="!isDownloadAll && data.prescriptionIds.length > 0" (click)="downloadAll()" mat-icon-button>
                    <mat-icon>cloud_download</mat-icon>
                </button>

            </td>
            <td style="width: 100%;">
                <div class="margin-top-medium full-width" (resized)="onResized($event)">
                    <h5 class="card-inline">Protocolo: <b>{{ data.protocol }}</b></h5>
                    <div class="card-inline margin-left-medium">
                        <h5> Paciente: <b>{{ data.patient }}</b></h5>
                    </div>
                    <div class="card-inline margin-left-medium">
                        <h5> Edad: <b>{{ data.patientAge }}</b></h5>
                    </div>
                </div>
                <div *ngIf="editing">
                    <app-text-editor-control [content]="content" (onEditorChange)="change($event)" elementId="tiny"></app-text-editor-control>
                </div>
                <mat-spinner *ngIf="converting">
                </mat-spinner>
                <iframe [style.width.px]="widthExp" height="400" *ngIf="!editing && !converting && getSafeResourceUrl()" [src]="getSafeResourceUrl()" type="application/pdf"></iframe>

            </td>
        </tr>
    </table>

</div>


<div class="clearfix">
    <div class="pull-right mt-5">
        <button [disabled]="converting && !deleting" mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
        <button [disabled]="converting && !deleting" mat-button type="button" *ngIf="isView" cdkFocusInitial (click)="delete()">Eliminar</button>
        <button [disabled]="converting && !deleting" mat-button type="button" *ngIf="editing" (click)="preView()">Previsualizar</button>
        <button [disabled]="converting && !deleting" mat-button type="button" *ngIf="!editing && !isView" (click)="aceptar()">Aceptar</button>
        <button [disabled]="converting && !deleting" mat-button type="button" *ngIf="!editing" (click)="volver()">Volver</button>
    </div>
</div>